import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { SiteLayout } from "@/components/site/SiteLayout";
import Home from "@/pages/Home";
import Why from "@/pages/Why";
import WhatWeBuildPage from "@/pages/WhatWeBuildPage";
import Services from "@/pages/Services";
import ServiceLanding from "@/pages/ServiceLanding";
import { SERVICE_LANDINGS } from "@/data/serviceLandings";
import HowItWorks from "@/pages/HowItWorks";
import BuildLevels from "@/pages/BuildLevels";
import Story from "@/pages/Story";
import Legal from "@/pages/Legal";
import Insights from "@/pages/Insights";
import Article from "@/pages/Article";
import Assessment from "@/pages/Assessment";
import Review from "@/pages/Review";
import Admin from "@/pages/Admin";
import Workspace from "@/pages/Workspace";
import PaymentReturn from "@/pages/PaymentReturn";
import Intake from "@/pages/Intake";
import Continue from "@/pages/Continue";
import AgreementPackage from "@/pages/AgreementPackage";
import Closing from "@/pages/Closing";

function App() {
  return (
    <div className="App dark">
      <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/why" element={<Why />} />
            <Route path="/what-we-build" element={<WhatWeBuildPage />} />
            <Route path="/services" element={<Services />} />
            {SERVICE_LANDINGS.map((p) => (
              <Route key={p.slug} path={`/${p.slug}`} element={<ServiceLanding />} />
            ))}
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/build-levels" element={<BuildLevels />} />
            <Route path="/our-story" element={<Story />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/insights/:slug" element={<Article />} />
          </Route>
          <Route path="/start" element={<Intake />} />
          <Route path="/assessment" element={<Assessment />} />
          <Route path="/review" element={<Review />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/workspace" element={<Workspace />} />
          <Route path="/agreement" element={<AgreementPackage />} />
          <Route path="/closing" element={<Closing />} />
          <Route path="/payment/success" element={<PaymentReturn />} />
          <Route path="/payment/cancel" element={<PaymentReturn />} />
          <Route path="/continue" element={<Continue />} />
          <Route path="/work" element={<Navigate to="/" replace />} />
          <Route path="/work/*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      </HelmetProvider>
      <Toaster position="top-center" theme="dark" richColors />
    </div>
  );
}

export default App;
